import { ResourceCenterViewModel } from '../loggedinweb-generated';

export class ResourceCenterDashboardViewModel {
	constructor(public model: ResourceCenterViewModel) { }
}
